import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/en';
import 'dayjs/locale/de';
import { APP_CONFIG } from '@/constants/app.constants';
import { localeStorage } from '@/utils/locale-storage.util';
import en from './locales/en.json';
import de from './locales/de.json';

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
  },
  lng: localeStorage.get() ?? APP_CONFIG.DEFAULT_LOCALE,
  fallbackLng: APP_CONFIG.DEFAULT_LOCALE,
  interpolation: { escapeValue: false },
  returnNull: false,
});

// The reservation calendar always starts the week on Sunday regardless of the active language —
// dayjs's built-in `de` locale defaults to Monday-first, so that default is overridden here.
dayjs.extend(updateLocale);
dayjs.updateLocale('en', { weekStart: 0 });
dayjs.updateLocale('de', { weekStart: 0 });
dayjs.locale(i18n.language);
i18n.on('languageChanged', (lng) => dayjs.locale(lng));

export default i18n;
